// AUTO-GENERATED by scripts/convert-rn-icons.ts from libs/component-library/src/lib/icons/icons.tsx - do not edit.
import { FxSvg, type FxSvgProps } from '../FxSvg.js';

export const FxChevronDownIcon = (props: FxSvgProps) => (
  <FxSvg width={12} height={7} viewBox="0 0 12 7" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 5.5L6.35355 5.85355L6 6.20711L5.64645 5.85355L6 5.5ZM11.3536 0.853553L6.35355 5.85355L5.64645 5.14645L10.6464 0.146447L11.3536 0.853553ZM5.64645 5.85355L0.646446 0.853554L1.35355 0.146447L6.35355 5.14645L5.64645 5.85355Z"
    />
  </FxSvg>
);
